import Core6RowAjax from './Core6RowAjax';
import * as CUSTOMEVENTS from './Core6Events';
import Core6RowDialogs from './Core6RowDialogs';
import Core6Component from './Core6Component';
import Core6ComponentDialogs from './Core6ComponentDialogs';
import Core6RowNudging from "./Core6RowNudging";

export default class Core6Utilities {
  static updateURL() {
    const newURL = document.getElementById('pageSlug').value;
    const newTitle = document.getElementById('pageTitle').value;
    const isTemplate = document.getElementById('isTemplate').value;
    const newPageId = document.getElementById('page_id').value;

    //console.log(newURL);
    if (window.parent.location.href.substr(window.parent.location.href.length - 6) === 'editor') {
      window.parent.history.pushState(null, newTitle, `${window.parent.location.href}/${newURL}`);
    } else {
      window.parent.history.pushState(null, newTitle, newURL);
    }

    Core6Utilities.getJQueryElement('.editTemplateString').html(`Editing Template: ${newTitle}`);
    Core6Utilities.getJQueryElement('.editPageString').html(`Editing Page: ${newTitle}`);
    Core6Utilities.getJQueryElement('.editorPageId').val(newPageId);

    //console.log(isTemplate);
    if (isTemplate === '1') {
      //console.log('is template');
      Core6Utilities.getJQueryElement('.isEditingTemplate').css('display', 'block');
      Core6Utilities.getJQueryElement('.isEditingPage').css('display', 'none');
    } else {
      //console.log('is page');
      Core6Utilities.getJQueryElement('.isEditingTemplate').css('display', 'none');
      Core6Utilities.getJQueryElement('.isEditingPage').css('display', 'block');
    }
  }

  static getParentFrameElementJQuery(selector) {
    return $(selector, window.parent.document);
  }

  static getiFrameElementJQuery(selector) {
    return $('#previewframe').contents().find(selector);
  }

  static getCurrentFrameElementJQuery(selector) {
    return $(selector);
  }

  static getParentFrameElement(selector) {
    return window.parent.document.querySelector(selector);
  }

  static getParentFrameElementAll(selector) {
    return window.parent.document.querySelectorAll(selector);
  }

  static getiFrameElement(selector) {
    const previewFrame = document.querySelector('#previewframe').contentWindow;
    return previewFrame.document.querySelector(selector);
  }

  static getiFrameElementAll(selector) {
    const previewFrame = document.querySelector('#previewframe').contentWindow;
    return previewFrame.document.querySelectorAll(selector);
  }

  static getCurrentFrameElement(selector) {
    return document.querySelector(selector);
  }

  static getCurrentFrameElementAll(selector) {
    return document.querySelectorAll(selector);
  }

  static getElement(selector) {
    let elem;
    try {
      elem = this.getiFrameElement(selector);
    } catch (e) {
    }

    if (elem === null || elem === undefined) {
      elem = this.getCurrentFrameElement(selector);
    }
    if (elem === null || elem === undefined) {
      elem = this.getParentFrameElement(selector);
    }
    return elem;
  }

  static getElementAll(selector) {
    let elem;
    try {
      elem = this.getiFrameElementAll(selector);
    } catch (e) {
    }

    if (elem === null || elem === undefined || elem.length === 0) {
      elem = this.getCurrentFrameElementAll(selector);
    }
    if (elem === null || elem === undefined || elem.length === 0) {
      elem = this.getParentFrameElementAll(selector);
    }
    return elem;
  }

  static getRowContainer(rowId) {
    const selector = `.core6-mainrow-container[data-row-id="${rowId}"]:not(.isTemplate)`;
    return Core6Utilities.getElement(selector);
  }

  static getJQueryRowContainer(rowId) {
    const selector = `.core6-mainrow-container[data-row-id="${rowId}"]:not(.isTemplate)`;
    return Core6Utilities.getJQueryElement(selector);
  }

  static getJQueryInnerRowContainer(rowId) {
    const selector = `.core6-innerrow-container[data-row-id="${rowId}"]:not(.isTemplate)`;
    return Core6Utilities.getJQueryElement(selector);
  }

  static getJQueryBlockHolder(rowId) {
    const selector = `.core6_block${rowId}_holder`;
    return Core6Utilities.getJQueryElement(selector);
  }

  static getJQueryElement(selector) {
    let elem;
    elem = this.getiFrameElementJQuery(selector);
    if (elem === null || elem === undefined || elem.length === 0) {
      elem = this.getCurrentFrameElementJQuery(selector);
    }
    if (elem === null || elem === undefined || elem.length === 0) {
      elem = this.getParentFrameElementJQuery(selector);
    }
    return elem;
  }

  static hideModal(selector) {
    const modal = Core6Utilities.getJQueryElement(selector);
    const body = Core6Utilities.getJQueryElement('body.modal-open');
    modal.removeClass('in');
    Core6Utilities.getJQueryElement('.modal-backdrop').remove();
    body.removeClass('modal-open');
    body.css('padding-right', '');
    modal.hide();
  }


  static addDialog(dialogHTML) {
    const dialogs = document.createElement('div');
    dialogs.innerHTML = dialogHTML;
    document.querySelector('#dialogContainer').appendChild(dialogs);
    setTimeout(() => {
      document.dispatchEvent(CUSTOMEVENTS.COMPONENT_DELETED);
      document.querySelector('body').dispatchEvent(CUSTOMEVENTS.RESET_SLIDER);
    }, 200);
  }

  static initDialogTabs() {
    console.log('init dialog tabs');

    const tabs = Core6Utilities.getJQueryElement('.core6_tabs > li');
    const firstTab = Core6Utilities.getJQueryElement('.core6_tabs > li:first-of-type');
    const tabContainers = Core6Utilities.getJQueryElement('.core6_tab_content > li');
    const firstTabContainer = Core6Utilities.getJQueryElement('.core6_tab_content > li:first-of-type');

    tabs.removeClass('selected');
    firstTab.addClass('selected');

    tabContainers.css('display', 'none');
    firstTabContainer.css('display', 'block');

    Core6RowNudging.refreshNudgeArrows();
  }

  static switchTab(evt) {
    console.log('switch tab');

    const rowId = $(this).attr('data-row-id');
    const index = $(this).attr('data-index');

    const tabs = Core6Utilities.getJQueryElement(`.core6_tabs > li[data-row-id="${rowId}"]`);
    tabs.removeClass('selected');

    $(`.core6_tabs > li[data-row-id="${rowId}"][data-index="${index}"]`).addClass('selected');

    $(`.core6_tab_content > li[data-row-id="${rowId}"]`).css('display', 'none');
    $(`.core6_tab_content > li[data-row-id="${rowId}"][data-index="${index}"]`).css('display', 'block');
  }

  static refreshDialogs() {
    //console.log('REFRESH DIALOGS');
    Core6RowAjax.refreshDialogs();
  }

  static refreshCSS() {
    // Quicker but screen flickers
    const oldLink = Core6Utilities.getJQueryElement('#pageCSS')[0];
    const queryString = `?reload=${new Date().getTime()}`;
    oldLink.href = oldLink.href.replace(/\?.*|$/, queryString);

    // Slower but no screen flicker
    /* const queryString = `?reload=${new Date().getTime()}`;
    const oldLink = Core6Utilities.getJQueryElement('#pageCSS');
    const head = document.getElementsByTagName('head')[0];
    const { body } = document;
    const css = document.createElement('link');
    const img = document.createElement('img');
    const cssURL = oldLink.attr('href').split(/[?#]/)[0];

    css.href = cssURL + queryString;
    css.rel = 'stylesheet';
    css.classList.add('pageStylesheet');
    css.id = 'pageCSS';
    head.appendChild(css);

    oldLink.addClass('CSSRemoveMe');

    img.onerror = () => {
      setTimeout(() => {
        Core6Utilities.getJQueryElement('.CSSRemoveMe').remove();
        const allCSS = Core6Utilities.getJQueryElement('.pageStylesheet');
        if (allCSS.length > 1) {
          for (let i = 0; i < allCSS.length - 1; i += 1) {
            allCSS[i].remove();
          }
        }
        body.removeChild(img);
        console.log('CSS Reloaded');
      }, 1000);
    };

    body.appendChild(img);
    img.src = cssURL; */
  }

  static replaceLoader(rowId, data) {
    const blockHolder = Core6Utilities.getJQueryBlockHolder(rowId);
    blockHolder.removeClass('core_6_loader');
    blockHolder.html(data);
    Core6Utilities.refreshCSS();
  }

  static replaceComponentLoader(componentId, data) {
    const componentHolder = Core6Utilities.getJQueryElement(`.core6_component${componentId}_holder`);
    componentHolder.removeClass('core_6_loader');
    componentHolder.html(data);
    Core6Utilities.refreshCSS();
  }

  static replaceFullBlock(rowId, data, refreshCSS = true) {
    const mainContainer = Core6Utilities.getJQueryRowContainer(rowId);
    mainContainer.replaceWith(data);
    if ( refreshCSS === true ) {
      Core6Utilities.refreshCSS();
    }
  }

  static modalCleanup() {
    const body = $('body');
    $('.modal-backdrop').remove();
    body.removeClass('modal-open');
    body.css('padding-right', 0);
  }

  static isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  static hasClass(element, cls) {
    return ` ${element.className} `.includes(` ${cls} `);
  }

  static findAncestor(element, cls) {
    while ((element = element.parentElement) && !element.classList.contains(cls)) ;
    return element;
  }

  static getNodeIndex(node) {
    let index = 0;
    while ((node = node.previousElementSibling)) {
      index++;
    }
    return index;
  }

  static getCoords(elem) {
    const box = elem.getBoundingClientRect();

    const {body} = document;
    const docEl = document.documentElement;

    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;

    const top = (box.top + scrollTop) - clientTop;
    const left = (box.left + scrollLeft) - clientLeft;

    return {elemTop: Math.round(top), elemLeft: Math.round(left)};
  }

  static initICheck() {
    //console.log('iCHECK');
    Core6Utilities.getJQueryElement('input.core6_icheck_block').iCheck({
      checkboxClass: 'icheckbox_flat-blue core6_block_checkbox',
      radioClass: 'iradio_flat-blue core6_block_radio',
    }).off('ifChanged', Core6RowDialogs.rowOptionsListener).on('ifChanged', Core6RowDialogs.rowOptionsListener);

    Core6Utilities.getJQueryElement('input.core6_icheck_component').iCheck({
      checkboxClass: 'icheckbox_flat-blue core6_component_checkbox',
      radioClass: 'iradio_flat-blue core6_component_radio',
    })/*.off('ifChanged', Core6ComponentDialogs.adminOptionsListener).on('ifChanged', Core6ComponentDialogs.adminOptionsListener)*/;
  }

  static swapElement(a, b) {
    // create a temporary marker div
    const aNext = $('<div>').insertAfter(a);
    a.insertAfter(b);
    b.insertBefore(aNext);
    // remove marker div
    aNext.remove();
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6Utilities.js